














import Component from "vue-class-component";
import { BaseRootPageComponent } from "../BaseRootPageComponent";
import { updateGTMGlobalVariables } from "@/utils/gtm";

@Component
export default class Unauthorized extends BaseRootPageComponent {
  created() {
    this.setTitle("Unauthorized");

    // updateGTMGlobalVariables(this);
  }
}
